export class QnoToSerialNoMap {
    serialQno: number;
    qno: number;
    
    constructor(serialQno: number, qno: number) {
        this.serialQno = serialQno;
        this.qno = qno;
    }
}